<template>
  <page :loading="loading">
    <template #content>
      <SubTopBar/>
      <v-breadcrumbs
        :items="bcItems"
        divider=">"
        class="mt-1"
        large
        />
      <v-row style="max-width: 950px">
        <v-col
          v-for="(item, i) in items"
          :key="i"
          cols="12"
          md="12"
          sm="12">
          <v-card>
            <v-card-subtitle v-text="item.title" />
            <v-card-title class="font-weight-light" v-text="item.message" />
            <v-col class="d-flex justify-end mb-6">
              <v-btn color="primary" @click="accept(item)">Accept</v-btn>
              <v-btn text @click="reject(item)">Reject</v-btn>
            </v-col>   
          </v-card>
        </v-col>
        <v-col
          v-for="(orgItem, i) in orgItems"
          :key="i"
          cols="12"
          md="12"
          sm="12">
          <v-card>
            <v-card-subtitle v-text="orgItem.title" />
            <v-card-title class="font-weight-light" v-text="orgItem.message" />
            <v-col class="d-flex justify-end mb-6">
              <v-btn color="primary" @click="acceptOrg(orgItem)">Accept</v-btn>
              <v-btn text @click="removeOrgInvitation(orgItem)">Reject</v-btn>
            </v-col>   
          </v-card>
        </v-col>
      </v-row>
      <v-col cols="12" md="4" sm="6" v-if="noNotifications">
        <h3 class="pl-5">you don't have any notifications</h3>
      </v-col>
    </template>
  </page>
</template>

<script>
import Strings from './Strings.js'
const Iam = require('iam')

export default {
  data: () => ({
    items: [],
    orgItems: [],
    loading: true
  }),
  computed: {
    bcItems: function () {
      return [
        {},
        {
          text: "Notifications",
          disabled: false,
          exact: true,
          href: "/notifications"
        }
      ]
    },
    userName() {
      return this.username
    },
    noNotifications() {
      return (this.items.length + this.orgItems.length == 0)
    }
  },
  watch: {
    userName(val) {
      if (val != null) {
        this.load()
      }
    }
  },
  mounted() {
    if(this.userName) {
      this.load()
    }
  },
  methods: {
    load: function () {
      this.$api.getNotifications(this.userName, this.callBack(
        response => {
          const items = []
          const orgItems = []
          response.invitations.forEach(invitation => {
            items.push({ 
              title: Strings(invitation, "organization_invite_title"),
              message: Strings(invitation, "organization_invite_message"),
              invite: invitation
            })
          })
          response.organizationinvitations.forEach(invitation => {
            orgItems.push({ 
              title: Strings(invitation, "organization_org_invite_title"),
              message: Strings(invitation, "organization_org_invite_message"),
              invite: invitation
            })
          })
          this.items = items
          this.orgItems = orgItems
          this.$store.state.notificationCounter = items.length + orgItems.length
        }, undefined, ()=> {
          this.loading = false
        }
      ))
    },
    accept: function (item) {
      this.$api.acceptMembership(item.invite, item.invite.organization, item.invite.role, this.username, this.callBack(
        ()=> {
          this.$store.state.notificationCounter--
          this.load()
        }
      ))
    },
    reject: function (item) {
      this.$api.rejectMembership(item.invite.organization, item.invite.role, this.username, this.callBack(()=> {
        this.load()
      }))
    },
    acceptOrg: function (orgItem) {
      const body = new Iam.JoinOrganizationInvitation()
      body.user = orgItem.invite.user
      body.organization = orgItem.invite.organization
      body.isorganization = true
      this.$api.acceptOrganizationInvite(orgItem.invite, orgItem.invite.user, orgItem.invite.organization, orgItem.invite.role, this.callBack(
        ()=> {
          this.$store.state.notificationCounter--
          this.load()
        }
      ))
    },
    removeOrgInvitation: function(orgItem) {
      this.$api.rejectOrganizationInvite(orgItem.invite.user, orgItem.invite.organization, orgItem.invite.role ,this.callBack(
        ()=> {
          this.$store.state.notificationCounter--
          this.load()
        }))
    }
  }
}
</script>